// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","container":"Terms_container__3t4az","address":"Terms_address__1M4Ht","content":"Terms_content__2IghQ"};